/**
 * Simple compact number formatter
 * 999 -> "999"
 * 999_999 -> "1000k"
 * 1_500_000 -> "1.5M"
 * 1_200_000_000 -> "1.2B"
 */
function formatNumberCompact(num: string | number, decimals: number = 1): string {
	const value = typeof num === "string" ? parseFloat(num) : num;

	if (isNaN(value)) {
		return "0";
	}

	return new Intl.NumberFormat("en-US", {
		notation: "compact",
		maximumFractionDigits: decimals,
		minimumFractionDigits: 0,
	}).format(value);
}

export { formatNumberCompact };
